import { render } from "./SideNavJSItem.vue?vue&type=template&id=f68262b0"
import script from "./SideNavJSItem.vue?vue&type=script&lang=js"
export * from "./SideNavJSItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__